import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "New Story",
    ongoingStories: "Ongoing Stories",
    completedStories: "Completed Stories",
    publicStories: "Public Stories",
    loadingStory: "Loading Story",
    pleaseWait: "Please wait while we load your story",
    newCharacter: "New Character",
    characterCard: {
      personality: "Personality",
      strengths: "Strengths",
      weaknesses: "Weaknesses",
      skills: "Skills"
    },
    search: {
      placeholder: "Search stories by title...",
      characters: "Search characters..."
    },
    filters: {
      title: "Filters",
      reset: "Reset",
      apply: "Apply",
      sortBy: "Sort by",
      filterByRole: "Filter by role",
      name: "Name",
      role: "Role",
      dateCreated: "Date Created",
      rating: "Rating",
      allRoles: "All Roles",
      roles: {
        all: "All roles",
        protagonist: "Main Character",
        antagonist: "Antagonist",
        deuteragonist: "Side Character",
        mentor: "Mentor",
        comic_relief: "Comic Relief",
        mysterious: "Mysterious Figure",
        love_interest: "Love Interest",
        anti_hero: "Anti-Hero",
        sidekick: "Sidekick",
        shapeshifter: "Shapeshifter Character",
        guardian: "Guardian",
        catalyst: "Catalyst Character",
        character: "Character",
        supporting: "Supporting Character"
      }
    },
    deleteStory: {
      confirmTitle: "Delete Story",
      confirmMessage: "Are you sure you want to delete this story? This action cannot be undone.",
      success: "Story Deleted",
      successMessage: "The story has been successfully deleted.",
      error: "Error",
      errorMessage: "Failed to delete the story. Please try again."
    },
    navigation: {
      stories: "Stories",
      characters: "Characters",
      publicStories: "Public Stories",
      stats: "Stats",
      more: "More"
    },
    loadingCharacters: "Loading characters...",
    noCharactersFound: "No characters found",
    createCharacter: {
      new: "New Character",
      title: "Create New Character",
      editTitle: "Edit Character",
      basicDetails: "Basic Details",
      characteristics: "Characteristics",
      avatarDetails: "Avatar Details",
      personalityTraits: "Personality Traits",
      form: {
        name: "Name",
        namePlaceholder: "Enter character name",
        description: "Description",
        descriptionPlaceholder: "Enter character description",
        role: "Role",
        selectRole: "Select character role",
        personality: "Personality",
        personalityTraits: "Personality Traits",
        personalityPlaceholder: "Enter personality traits",
        strengths: "Strengths",
        strengthsPlaceholder: "Enter character strengths",
        weaknesses: "Weaknesses",
        weaknessesPlaceholder: "Enter character weaknesses",
        skills: "Skills",
        skillsPlaceholder: "Enter character skills",
        addTrait: "Add Trait",
        addStrength: "Add Strength",
        addWeakness: "Add Weakness",
        addSkill: "Add Skill",
        "add.Personality.Traits": "Add Personality Traits",
        "add.Strengths": "Add Strengths",
        "add.Weaknesses": "Add Weaknesses",
        "add.Skills": "Add Skills",
        unnamedCharacter: "Unnamed Character",
        cancel: "Cancel",
        create: "Create Character",
        update: "Update Character"
      },
      buttons: {
        create: "Create Character",
        update: "Update Character",
        cancel: "Cancel",
        updating: "Updating...",
        creating: "Creating...",
      },
      avatarGenerator: {
        genderLabel: "Appearance Type",
        genderPlaceholder: "Select appearance type",
        ageLabel: "Age Group",
        agePlaceholder: "Select age group",
        hairLabel: "Hair Description",
        hairPlaceholder: "e.g., Long curly black hair",
        eyeLabel: "Eye Color",
        eyePlaceholder: "e.g., Deep blue",
        clothingLabel: "Clothing Style",
        clothingPlaceholder: "e.g., Medieval armor",
        expressionLabel: "Facial Expression",
        expressionPlaceholder: "e.g., Confident smile",
        generateButton: "Generate Avatar",
        generating: "Generating...",
        previewLabel: "Generated Avatar",
        selectTitle: "Select Avatar",
        selectDescription: "Choose one of the generated avatars for your character.",
        partialSuccess: "Some images failed to load",
        someImagesFailed: "Some images failed to load. Please try again.",
        selectPreferred: "Select Preferred Avatar",
        genderOptions: {
          male: "Human - Male",
          female: "Human - Female",
          // New animal options
          cat: "Animal - Cat",
          dog: "Animal - Dog",
          wolf: "Animal - Wolf",
          fox: "Animal - Fox",
          rabbit: "Animal - Rabbit",
          bird: "Animal - Bird",
          reptile: "Animal - Reptile",
          // Existing fantasy options
          elf: "Fantasy - Elf",
          dwarf: "Fantasy - Dwarf",
          orc: "Fantasy - Orc",
          vampire: "Fantasy - Vampire",
          werewolf: "Fantasy - Werewolf",
          fairy: "Fantasy - Fairy",
          angelic: "Fantasy - Angelic Being",
          demonic: "Fantasy - Demonic Being",
          dragonborn: "Fantasy - Dragonborn",
          centaur: "Fantasy - Centaur",
          mermaid: "Fantasy - Mermaid/Merman",
          humanoid_alien: "Sci-Fi - Humanoid Alien",
          insectoid_alien: "Sci-Fi - Insectoid Alien",
          reptilian_alien: "Sci-Fi - Reptilian Alien",
          cyborg: "Sci-Fi - Robotic/Cyborg",
          energy_being: "Sci-Fi - Energy-Based Lifeform",
          tentacled: "Sci-Fi - Tentacled Creature",
          cat_person: "Animal - Cat Person",
          dog_person: "Animal - Dog Person",
          wolf_person: "Animal - Wolf Person",
          fox_person: "Animal - Fox Person",
          rabbit_person: "Animal - Rabbit Person",
          bird_person: "Animal - Bird Person",
          reptile_person: "Animal - Reptile Person",
          treant: "Mythical - Walking Tree",
          flower: "Mythical - Sentient Flower",
          vine: "Mythical - Living Vine",
          mushroom: "Mythical - Talking Mushroom",
          vegetable: "Mythical - Animated Plant",
          golem: "Mythical - Golem",
          ghost: "Mythical - Ghost/Spirit",
          shapeshifter: "Mythical - Shapeshifter"
        },
        ageOptions: {
          child: "Child",
          teen: "Teen",
          adult: "Adult",
          elderly: "Elderly"
        },
        success: {
          title: "Avatar Generated",
          description: "Your character's avatar has been created successfully."
        },
        error: {
          title: "Generation Failed",
          description: "Failed to generate avatar. Please try again."
        },
        upload: {
          button: "Upload Avatar",
          uploading: "Uploading...",
          success: {
            title: "Avatar uploaded",
            description: "Your avatar has been uploaded successfully"
          },
          error: {
            title: "Upload failed",
            fileTooLarge: "Avatar image must be less than 5MB",
            invalidType: "Please upload an image file",
            failed: "Failed to upload avatar image"
          },
          loading: "Loading image..."
        }
      },
      messages: {
        successCreated: {
          title: "Character Created",
          description: "Your character has been saved successfully.",
        },
        successUpdated: {
          title: "Character Updated",
          description: "Your character has been updated successfully.",
        },
        errorLoad: {
          title: "Error",
          description: "Failed to load character data",
        },
        errorSave: {
          title: "Error",
          description: "Failed to save character. Please try again.",
        },
        validation: {
          characterName: {
            title: "Missing Name",
            description: "Character name is required.",
          },
        },
      },
    },
    characterTabs: {
      myCharacters: "My Characters",
      publicCharacters: "Public Characters"
    },
    characterManagement: {
      delete: {
        title: "Delete Character",
        confirmMessage: "Are you sure you want to delete this character? This action cannot be undone.",
        cancel: "Cancel",
        delete: "Delete",
        deleting: "Deleting...",
        success: {
          title: "Character deleted",
          description: "The character has been successfully deleted"
        },
        error: {
          title: "Error",
          description: "Failed to delete character"
        }
      },
      visibility: {
        setPrivate: "Character set to private",
        setPublic: "Character set to public", 
        nowPrivate: "The character is now private",
        nowPublic: "The character is now visible to everyone",
        error: "Error",
        updateFailed: "Failed to update character visibility"
      },
      rating: {
        submitted: "Rating submitted",
        thankYou: "Thank you for rating this character!",
        error: "Error",
        failed: "Failed to submit rating"
      }
    },
    suggestions: {
      personalities: {
        adaptable: "Adaptable",
        ambitious: "Ambitious",
        brave: "Brave",
        charismatic: "Charismatic",
        compassionate: "Compassionate",
        confident: "Confident",
        creative: "Creative",
        determined: "Determined",
        diplomatic: "Diplomatic",
        empathetic: "Empathetic",
        honorable: "Honorable",
        humble: "Humble",
        humorous: "Humorous",
        innovative: "Innovative",
        loyal: "Loyal",
        optimistic: "Optimistic",
        patient: "Patient",
        resilient: "Resilient",
        wise: "Wise",
        analytical: "Analytical",
        cautious: "Cautious",
        eccentric: "Eccentric",
        mysterious: "Mysterious",
        pragmatic: "Pragmatic",
        reserved: "Reserved",
        stoic: "Stoic",
        arrogant: "Arrogant",
        cynical: "Cynical",
        greedy: "Greedy",
        hot_tempered: "Hot-tempered",
        impulsive: "Impulsive",
        manipulative: "Manipulative",
        obsessive: "Obsessive",
        paranoid: "Paranoid",
        prideful: "Prideful",
        reckless: "Reckless",
        ruthless: "Ruthless",
        vengeful: "Vengeful"
      },
      skills: {
        leadership: "Leadership",
        negotiation: "Negotiation",
        perception: "Perception",
        persuasion: "Persuasion",
        investigation: "Investigation",
        survival: "Survival",
        deception: "Deception",
        intimidation: "Intimidation",
        performance: "Performance",
        medicine: "Medicine",
        sword_fighting: "Sword Fighting",
        archery: "Archery",
        martial_arts: "Martial Arts",
        stealth: "Stealth",
        acrobatics: "Acrobatics",
        marksmanship: "Marksmanship",
        hand_to_hand: "Hand to Hand",
        tactical: "Tactical",
        magic: "Magic",
        elemental_control: "Elemental Control",
        healing: "Healing",
        necromancy: "Necromancy",
        prophecy: "Prophecy",
        shapeshifting: "Shapeshifting",
        telepathy: "Telepathy",
        telekinesis: "Telekinesis",
        alchemy: "Alchemy",
        summoning: "Summoning",
        hacking: "Hacking",
        piloting: "Piloting",
        robotics: "Robotics",
        cybernetics: "Cybernetics",
        nanotech: "Nanotech",
        quantum_physics: "Quantum Physics",
        ai_programming: "AI Programming",
        bioengineering: "Bioengineering",
        time_manipulation: "Time Manipulation",
        energy_weapons: "Energy Weapons",
        crafting: "Crafting",
        cooking: "Cooking",
        music: "Music",
        art: "Art",
        writing: "Writing",
        forgery: "Forgery",
        invention: "Invention",
        linguistics: "Linguistics",
        history: "History",
        science: "Science",
        psychology: "Psychology",
        archaeology: "Archaeology",
        cryptography: "Cryptography",
        strategy: "Strategy",
        mythology: "Mythology",
        economics: "Economics"
      }
    },
    upgradeForMore: "Upgrade for more",
    storiesRemaining: "Stories remaining",
    storiesAvailable: "Stories available",
    by: "by",
    anonymous: "Anonymous",
    completed: "Completed",
    public: "Public",
    makePublic: "Make public",
    makePrivate: "Make private",
    upgradeToMakePublic: "Upgrade to make stories public",
    error: "Error",
    rating: {
      submitted: "Rating submitted",
      thankYou: "Thank you for rating this story!",
      failed: "Failed to submit rating"
    },
    upgrade: {
      required: "Upgrade Required",
      description: "Upgrade your account to make stories public and share them with others.",
      shareStories: "Share your stories with a premium subscription",
      now: "Upgrade Now"
    },
    startedTime: "Started {{time}}",
    storyVisibility: {
      madePublic: "Story made public",
      madePrivate: "Story made private", 
      publicDescription: "Others can now view this story",
      privateDescription: "This story is now private"
    },
    stats: {
      tabs: {
        badges: "Badges",
        stories: "Stories",
        characters: "Characters",
        engagement: "Engagement"
      },
      badges: {
        loading: "Loading badges...",
        earned: "Earned:",
        error: {
          title: "Error",
          loadBadges: "Failed to load badges",
          loadProgress: "Failed to load badge progress"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "Prolific Writer",
            description: "Complete 100 stories",
            category: "Writing"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "Historical Novelist",
            description: "Complete 3 historical fiction stories",
            category: "Genres"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "Endurance Writer",
            description: "Write responses for 30+ days in a row",
            category: "Writing"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "Mystery Solver",
            description: "Complete 10 mystery stories",
            category: "Genres"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "Dialogue Architect",
            description: "Contribute 10,000 words of dialogue through interactions",
            category: "Writing"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "Top Critic",
            description: "Rate 20 characters",
            category: "Community"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "Relationship Builder",
            description: "Create relationships between 5 characters",
            category: "Characters"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "Viral Sensation",
            description: "A story gets 1,000+ views",
            category: "Social"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "Deep Thinker",
            description: "Add a detailed backstory to 3 characters",
            category: "Characters"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "Social Butterfly",
            description: "Rate 20 stories",
            category: "Community"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "Horror Aficionado",
            description: "Complete 20 horror stories",
            category: "Genres"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "Series Starter",
            description: "Publish the first story in a multi-part series",
            category: "Writing"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "Balanced Voice",
            description: "Achieve more user-edited responses",
            category: "Writing"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "Referral Master",
            description: "Invite and get 10 friends to join",
            category: "Social"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "Encourager",
            description: "Give 20+ positive reactions to stories",
            category: "Community"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "Master of Prompts",
            description: "Provide 100 unique user prompts",
            category: "Writing"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "Promoter",
            description: "Share 5 stories to social media",
            category: "Social"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "AI Whisperer",
            description: "Accept AI-generated responses 500 times",
            category: "Writing"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "Character Artist",
            description: "Generate an avatar for a character",
            category: "Characters"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "Daily Writer",
            description: "Create a story for 7 consecutive days",
            category: "Writing"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "Dynamic Cast",
            description: "Use 20+ different characters in stories",
            category: "Characters"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "Experimenter",
            description: "Complete 10+ different genres in stories",
            category: "Genres"
          }
        }
      },
      storyStats: {
        loading: "Loading stats...",
        totalStories: "Total Stories",
        completed: "Completed",
        published: "Published",
        averageRating: "Average Rating",
        categoryRelationships: "Story Category Relationships",
        primaryCategory: "Primary Category",
        secondaryCategory: "Secondary Category",
        selectCategory: "Select category",
        genre: "Genre",
        themes: "Themes",
        environment: "Environment",
        noCategoryData: "No category data available",
        lessFrequent: "Less frequent",
        moreFrequent: "More frequent",
        usageDescription: "Shows how often categories are used together in your stories",
        stories: "stories",
        noDataAvailable: "No data available",
      },
      characterStats: {
        loading: "Loading character stats...",
        totalCharacters: "Total Characters",
        publicCharacters: "Public Characters",
        averageRating: "Average Rating",
        traitRelationships: "Character Trait Relationships",
        primaryTraitType: "Primary Trait Type",
        secondaryTraitType: "Secondary Trait Type",
        selectTraitType: "Select trait type",
        personalityTraits: "Personality Traits",
        strengths: "Strengths",
        weaknesses: "Weaknesses",
        skills: "Skills",
        noTraitData: "No trait relationship data available",
        lessFrequent: "Less frequent",
        moreFrequent: "More frequent",
        usageDescription: "Shows how often different traits appear together in your characters",
        characters: "characters"
      },
      engagementStats: {
        loading: "Loading statistics...",
        totalStories: "Total Stories",
        avgCustomization: "Avg. Customization",
        avgWordCount: "Avg. Word Count",
        currentStreak: "Current Streak",
        days: "days",
        monthlyProgress: "Monthly Progress"
      }
    },
    author: {
      title: 'Author Profile',
      credits: 'Story Credits',
      creditsAvailable: 'You have {{count}} credits available',
      memberSince: 'TaleCraft Member',
      loading: 'Loading...',
      recentBadges: 'Recent Badges',
      noBadgesYet: 'No badges earned yet',
      earnedOn: 'Earned on {{date}}',
      more: 'more'
    },
    access: {
      restricted: "Restricted Access",
      loginRequired: "You need to be logged in to access this page.",
    }
  }
};
